import React from "react";
import moment from "moment";
import { colour } from "../style/base-theme";

export default function AxisLabel(props) {
  const {
    payload: { value },
    data: { currency_unit, energy_unit },
    textAnchor,
    y,
    x,
    data,
    index,
    fontSize
  } = props;

  return (
    <svg>
      <text
        fill={colour.grey[200]}
        fontWeight={600}
        fontSize={14}
        textAnchor={textAnchor}
      >
        <tspan x={x} y={y + 32}>
          {value}
        </tspan>
        <tspan x={x} y={y + 47} fontSize={12} fill={colour.grey[200]}>
          {value === "Cost" ? currency_unit : energy_unit}
        </tspan>
      </text>
      <image
        x={x - 20}
        y={y}
        width={20}
        height={20}
        xlinkHref="/icons/InformetisIcon.png"
      />
      <image
        x={x}
        y={y}
        width={20}
        height={20}
        xlinkHref="/icons/HomeIconGrey.svg"
      />
    </svg>
  );
}
